import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BasketOperationMode } from '../../enums/basket-operation-mode.enum';
import { SessionStorageService } from '../../services/session-storage.service';
import { BasketService } from '../../services/basket.service';
import { BasketResponse } from '../../dtos/basket.response.dto';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../dialog/error-dialog/error-dialog.component';
import { YesNoDialogComponent } from '../dialog/yes-no-dialog/yes-no-dialog.component';
import { DialogService } from '../../services/dialog.service';
import { BasketItem } from '../../models/basket-item';


@Component({
    standalone: false,
    selector: 'basket',
    templateUrl: './basket.component.html',
    styleUrls: ['./basket.component.scss']
})
export class BasketComponent implements OnInit {
    public basketService = inject(BasketService);
    private sessionStorageService = inject(SessionStorageService);
    private dialogService = inject(DialogService);
    public translateService = inject(TranslateService);

    @Input() basketOpMode: string; // F == Floating Side    C == center
    @Input() readonlyMode: boolean = false;
    loaded: boolean;
    tickets: BasketResponse;
    currLocale: string;
    eBasketOperationMode: BasketOperationMode;
    @Output() goToPayment = new EventEmitter<void>();

    ngOnInit() {
        const sessionStorageUrlParams = this.sessionStorageService.getUrlParams();
        if (!sessionStorageUrlParams)
            return;

        this.currLocale = sessionStorageUrlParams.Language;

        this.loaded = true;

        this.basketService.basketContent$.subscribe(event => {
            this.tickets = event;
        })
    }

    incrementQuantity(item: BasketItem) {
        this.basketService.incrementQuantity(item.ticketId, item.date, 1, item.areaId);
    }

    decrementQuantity(item: BasketItem) {
        if (item.quantity > 1) {
            this.basketService.decrementQuantity(item.ticketId, item.date, 1, item.areaId);
        }
    }

    async removeTicket(item: BasketItem) {
        const result = await this.dialogService.openYesNoDialog(this.translateService.instant("shopping.delete_from_basket_question"), this.translateService.instant("common.yes"), this.translateService.instant("common.no"));
        if (result)
            this.basketService.removeFromBasket(item.ticketId, item.date, item.areaId);
    }

    // style classes functions 
    basketWrapperFloat(opMode: string) {
        let styles = {};
        if (opMode === "F") {
            styles["background-color"] = "white";
            styles["display"] = "block";
            styles["padding"] = "10px";
            styles["box-shadow"] = "0 3px 10px rgb(0 0 0 / 0.2)";
        } else {
            styles["background-color"] = "white";
            styles["display"] = "block";
        }
        return styles;
    }

    ticketName(opMode: string) {
        let styles = {};
        styles["font-family"] = "Roboto";
        if (opMode === "F") {
            styles["font-size"] = "15px";
            styles["font-weight"] = "700";
        } else {
            styles["font-size"] = "15px";
            styles["font-weight"] = "700";
        }
        return styles;
    }

    ticketPriceStyle(hasError: boolean) {
        let styles = {};
        styles["font-family"] = "Roboto";
        styles["font-size"] = hasError ? "14px" : "15px";
        styles["font-weight"] = "700";

        return styles;
    }

    isAnyCalculatableItem(): boolean {
        if (!this.basketService || !this.basketService.basketResponse || !this.basketService.basketResponse.items || this.basketService.basketResponse.items.length < 1)
            return false;

        return this.basketService.basketResponse.items.filter(ticket => !ticket.hasError).length > 0;
    }
}

